export default "__VITE_ASSET__SbiTXwQU__"